var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:({
    content: _vm.tooltipText,
    delay: { show: 1500, hide: 0 },
    hideOnClick: true,
  }),expression:"{\n    content: tooltipText,\n    delay: { show: 1500, hide: 0 },\n    hideOnClick: true,\n  }",modifiers:{"top":true}}],staticClass:"text-xxs text-slate-500 dark:text-slate-500 leading-4 ml-auto hover:text-slate-900 dark:hover:text-slate-100"},[_c('span',[_vm._v(_vm._s(`${_vm.createdAtTime} • ${_vm.lastActivityTime}`))])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }